import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';

import { Content, Footer, Title } from '../DefaultStyles/Shared';
import { Container, Body } from '../DefaultStyles/Details';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import AnswerButton from '../../components/Assessment/AnswerButton';
import ShareDrawer from '../../components/ShareDrawer';
import TransitionContainer from '../../components/Transition/TranstionContainer';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes, StatesAbbreviation } from '../../utils/enums';
import { onGoToStep } from './actions';
import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

const VoteRegistrationStep3 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={24}
    >
        <Container>
            <Overlay />
            <OverlayPublisher />
            <Body>
                <WidgetHeader />
                <Content>
                    <Title
                        dangerouslySetInnerHTML={{
                            __html: props.title
                        }}
                    />
                </Content>
                <AutoScalingButtonSet mobileStyled={true}>
                    <AnswerButton
                        text={props.buttonText1}
                        useLoadingSpinner={true}
                        key="0"
                        onClick={() => {
                            props.setExitingCardProps(
                                'voteRegistration',
                                props,
                                props.activeAction
                            );
                            props.onGoToStep(
                                'success',
                                'forward',
                                props.apiRequestData,
                                props.answerId,
                                [],
                                props.formData,
                                props.actionIdentifier,
                                props.isMultiActionsCard,
                                props.actionCompletedTime()
                            );
                            window.open(props.registrationUrl, '_blank');
                        }}
                    />
                    <AnswerButton
                        text={props.buttonText2}
                        useLoadingSpinner={false}
                        key="1"
                        onClick={() => {
                            props.setExitingCardProps(
                                'voteRegistration',
                                props,
                                props.activeAction
                            );
                            props.onGoToStep(4, 'forward');
                        }}
                    />
                </AutoScalingButtonSet>
                <Footer>
                    <ShareDrawer rightAlign backgroundColor={'#fff'} />
                </Footer>
            </Body>
        </Container>
    </TransitionContainer>
);

VoteRegistrationStep3.propTypes = {
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    answerId: PropTypes.number,
    apiRequestData: PropTypes.object.isRequired,
    buttonText1: PropTypes.string,
    buttonText2: PropTypes.string,
    formData: PropTypes.object,
    isBackTransition: PropTypes.bool,
    isMultiActionsCard: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool,
    onGoToStep: PropTypes.func,
    registrationUrl: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    title: PropTypes.string
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/step3'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const stateName =
            StatesAbbreviation[(state.voteRegistration.formData || {}).stateId] ||
            (state.localRep.localRepData.address || {}).state ||
            state.widget.endUserLocation?.regionName;

        return {
            actionCompletedTime: getActionCompletedTime(state, 'voteRegistration'),
            actionIdentifier: state.widget.activeAction.identifier,
            activeAction: state.widget.activeAction,
            answerId:
                state.voteRegistration.completeVoteRegistration.voteRegistrationAnswerId,
            apiRequestData: state.widget.apiRequestData,
            buttonText1: `Register Online with ${stateName}`,
            buttonText2: 'Continue with Mail Registration',
            formData: state.voteRegistration.formData,
            isBackTransition: state.voteRegistration.isBackTransition,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isSubmitting: state.voteRegistration.isSubmitting,
            registrationUrl:
                state.voteRegistration.completeVoteRegistration.registrationUrl,
            title:
                "You are eligible to register to vote online through your state's website."
        };
    },
    { onGoToStep, setExitingCardProps }
)(VoteRegistrationStep3);
